import { forwardRef } from 'react';

import { getAdditionalFieldProps } from 'checks/fields';
import WholeNumberInline from 'components/Inputs/inline/TextInput/presets/WholeNumber';
import { IconWithTooltip } from 'pages/Common/components/LinkWithIconTooltip/IconWithTooltip';
import { StyledInfoWrapper } from 'components/Fields/InlineTableFieldInput/styles';
import { withCellWrapper } from './helpers';

const _WholeNumberCell = forwardRef(
  (
    {
      field,
      entityId,
      entityAccess,
      onSubmit,
      value,
      objectId,
      serviceToUse,
      fetchUrl,
      handleUpdateFieldOption,
      handleUpdateTableRecords,
      menuLeftButton,
      menuRightButton,
      placeholder,
      info,
      showDisplayNameTooltip,
      column,
      readOnly,
      onAutoFocus,
      editable,
      ...others
    },
    ref
  ) => {
    const isInheritedPercentage = !!(info && editable && !readOnly);
    return (
      <StyledInfoWrapper isInheritedPercentage={isInheritedPercentage}>
        <WholeNumberInline
          ref={ref}
          {...others}
          value={value}
          onSubmit={onSubmit}
          readOnly={readOnly}
          onAutoFocus={onAutoFocus}
          field={field}
          entityId={entityId}
          {...getAdditionalFieldProps(field, info, placeholder)}
        />
        {isInheritedPercentage ? <IconWithTooltip label={info} /> : null}
      </StyledInfoWrapper>
    );
  }
);

export const WholeNumberCell = withCellWrapper(_WholeNumberCell);
